import { render, staticRenderFns } from "./tm-menu-selection.vue?vue&type=template&id=bedcc4f4&scoped=true&"
import script from "./tm-menu-selection.vue?vue&type=script&lang=ts&"
export * from "./tm-menu-selection.vue?vue&type=script&lang=ts&"
import style0 from "./tm-menu-selection.vue?vue&type=style&index=0&id=bedcc4f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedcc4f4",
  null
  
)

export default component.exports